"use strict";
/**
 * Created by Pankaj on 2019-12-13.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureBuyTicket = void 0;
const Label_1 = require("@nolimit/slot-launcher/bin/gui/labels/Label");
const IconToggleButton_1 = require("@nolimit/slot-launcher/bin/gui/buttons/IconToggleButton");
const NolimitPromotionPlugin_1 = require("../NolimitPromotionPlugin");
const PromoPanelAssetConfig_1 = require("../config/PromoPanelAssetConfig");
const PointerStateColorSet_1 = require("@nolimit/slot-launcher/bin/gui/buttons/states/sets/PointerStateColorSet");
const PointerStateIconSet_1 = require("@nolimit/slot-launcher/bin/gui/buttons/states/sets/PointerStateIconSet");
const Icon_1 = require("@nolimit/slot-launcher/bin/gui/displayobjects/Icon");
const PromoPanelLabelIDs_1 = require("../enums/PromoPanelLabelIDs");
const PromoPanelTextStyles_1 = require("../config/PromoPanelTextStyles");
const PromoPanelButtonIDs_1 = require("../enums/PromoPanelButtonIDs");
const PromoPanelConfig_1 = require("../config/PromoPanelConfig");
const PromoPanelTextLabel_1 = require("../feature/PromoPanelTextLabel");
const ImgLoader_1 = require("@nolimit/slot-launcher/bin/loader/ImgLoader");
const CurrencyUtils_1 = require("../utils/CurrencyUtils");
class FeatureBuyTicket extends PIXI.Container {
    get price() {
        return this._price;
    }
    set price(value) {
        //this._price = value; //#329
        this._price = +value.toFixed(2);
    }
    get allowedByOptions() {
        return this._allowedByOptions;
    }
    set allowedByOptions(value) {
        this._allowedByOptions = value;
    }
    get featureData() {
        return this._featureData;
    }
    get nextBetPrice() {
        return this._nextBetPrice;
    }
    set totalCost(value) {
        this._totalCost = value;
        const formatted = CurrencyUtils_1.CurrencyUtils.formatWithDecimalCutOff(value);
        this._priceLabel.value = formatted;
    }
    constructor(featureData, buyButtonCallback, buyButtonTexture) {
        super();
        this._allowedByOptions = true;
        this._isExceededBetLimit = true;
        this._buyButtonCallback = buyButtonCallback;
        this._featureData = featureData;
        this._maxBetLevel = featureData.getMaxBet();
        this.init(buyButtonTexture);
    }
    updateButtons() {
        const balance = NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.balance.getAmount();
        if (this._price > balance || NolimitPromotionPlugin_1.NolimitPromotionPlugin.isFreeBet || this._isExceededBetLimit || !this._allowedByOptions) {
            this._buyButton.enable(false);
            this._buyButton.alpha = PromoPanelConfig_1.PromoPanelConfig.DISABLE_BTN_ALPHA;
            this._buyLabel.setStyle(PromoPanelTextStyles_1.PromoPanelTextStyles.GAME_FEATURE_BUY_TEXT_DISABLED);
        }
        else {
            this._buyButton.enable(true);
            this._buyButton.alpha = PromoPanelConfig_1.PromoPanelConfig.ENABLE_BTN_ALPHA;
            this._buyLabel.setStyle(PromoPanelTextStyles_1.PromoPanelTextStyles.GAME_FEATURE_BUY_TEXT);
        }
    }
    resize(isLandscapeLayout) {
        this.scale.set(1);
        this._priceLabel.onResize();
        this._buyLabel.onResize();
    }
    createCostLabels() {
        const container = new PIXI.Container();
        const labels = new PIXI.Container();
        const betLabel = new Label_1.Label(NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.translations.translate(PromoPanelLabelIDs_1.PromoPanelLabelIDs.BUY_FEATURE_COST), PromoPanelTextStyles_1.PromoPanelTextStyles.GAME_FEATURE_COST_TEXT);
        labels.addChild(betLabel);
        labels.pivot.set(labels.width * 0.5, 0);
        this._priceLabel = new PromoPanelTextLabel_1.PromoPanelTextLabel("", PromoPanelTextStyles_1.PromoPanelTextStyles.GAME_FEATURE_PRICE_STYLE, {
            landscapeMaxWidth: 190,
            portraitMaxWidth: 190
        });
        this._priceLabel.anchor.set(0.5, 0);
        this._priceLabel.position.set(0, betLabel.height + 5);
        container.addChild(labels);
        container.addChild(this._priceLabel);
        return container;
    }
    updatePrice(currentBet, currentSpinCount = 1) {
        this.totalCost = (+currentBet * this._featureData.price) * currentSpinCount;
        this.price = (+currentBet * this._featureData.price);
        this._isExceededBetLimit = +currentBet > this._maxBetLevel;
        this.updateButtons();
    }
    updateNextBetPrice(nextBet, currentSpinCount = 1) {
        this._nextBetPrice = +nextBet * this._featureData.price * currentSpinCount;
    }
    init(buyButtonTexture) {
        const ticketGfx = new PIXI.Sprite(ImgLoader_1.ImgLoader.getImgTexture(PromoPanelAssetConfig_1.PromoPanelAssetConfig.TICKET));
        const costLabels = this.createCostLabels();
        costLabels.position.set(115, 40);
        const colors = new PointerStateColorSet_1.PointerStateColorSet(0xffffffff);
        let onIcons1 = new PointerStateIconSet_1.PointerStateIconSet(new Icon_1.Icon(buyButtonTexture));
        this._buyButton = new IconToggleButton_1.IconToggleButton(PromoPanelButtonIDs_1.PromoPanelButtonIDs.BUY, onIcons1, colors);
        this._buyButton.addClickCallback(() => {
            this._buyButtonCallback(this._buyButton, this._featureData);
        });
        this._buyButton.toggled = false;
        this._buyButton.enable(false);
        this._buyButton.position.set(19, 140);
        this._buyLabel = new PromoPanelTextLabel_1.PromoPanelTextLabel(NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.translations.translate(PromoPanelLabelIDs_1.PromoPanelLabelIDs.BUY), PromoPanelTextStyles_1.PromoPanelTextStyles.GAME_FEATURE_BUY_TEXT, {
            landscapeMaxWidth: this._buyButton.width - 30,
            portraitMaxWidth: this._buyButton.width - 30
        });
        this._buyLabel.position.set(this._buyButton.width * 0.5, 38);
        this._buyLabel.anchor.set(0.5, 0.5);
        this._buyButton.addChild(this._buyLabel);
        const mask = new PIXI.Graphics();
        mask.clear();
        mask.beginFill(0xFF0000, 1);
        mask.drawRect(0, 0, PromoPanelAssetConfig_1.PromoPanelAssetConfig.GAME_FEATURE_MASK_WIDTH, ticketGfx.height - 13);
        mask.pivot.set(PromoPanelAssetConfig_1.PromoPanelAssetConfig.GAME_FEATURE_MASK_WIDTH / 2, 0);
        mask.position.set(440, 3);
        const featureImg = new PIXI.Sprite(ImgLoader_1.ImgLoader.getImgTexture(this._featureData.name));
        featureImg.anchor.set(0.5, 0.5);
        featureImg.position.set(440, mask.y + mask.height * 0.5);
        featureImg.mask = mask;
        this.addChild(ticketGfx, featureImg, costLabels, this._buyButton, mask);
    }
}
exports.FeatureBuyTicket = FeatureBuyTicket;
//# sourceMappingURL=FeatureBuyTicket.js.map